module.exports = __webpack_public_path__ + "img/omni.774e137a.svg";